import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BsChevronDown } from 'react-icons/bs';

import { setCreditsOpened } from '../../../store/reducers/mainReducer';

import { ADALandmarks, ADAWidgitRoles } from '../../../models/ADA';
import './Credits.scss';

const Credits = ({ showBar, onClick, isLightBg }) => {
    const dispatch = useDispatch();
    const isInitialized = useSelector(state => state.data.initialized);
    const global = useSelector(state => state.data.cms.global);
    const [showContent, setShowContent] = useState(false);
    const formatCredits = (cms) => {
        if(!isInitialized || !global || !cms || !cms.Credits || cms.Credits.length <= 0){
            return null;
        }
        let allCredits = [];
        let creditsBuffer = [];
        let rowCounter = 0;
        cms.Credits.forEach((credit, i) => {
          const el = (<div key={i} className="cpvi-grid-col w3"><div className="bn-cb-credit-unit" dangerouslySetInnerHTML={{ __html:credit.Text }}></div></div>);
          creditsBuffer.push(el);
          if (creditsBuffer.length === 4) {
            allCredits.push(
              <div key={rowCounter++} className="cpvi-grid-row a-row" >
                {[ ...creditsBuffer ]}
              </div>
            );
            creditsBuffer = [];
          }
        });
        if (creditsBuffer.length > 0) {
          allCredits.push(
            <div key={rowCounter} className="cpvi-grid-row a-row">
              {[ ...creditsBuffer ]}
            </div>
          );
        }
        return allCredits;
    };

    const onCreditsClick = () => {
        setShowContent(!showContent);
        dispatch(setCreditsOpened(!showContent));
        onClick(!showContent);
    }

    const onBackgroundClicked = () => {
        dispatch(setCreditsOpened(false));
        setShowContent(false);
        onClick(false);
    }

    useEffect(() => {
        if(!showBar){
            setShowContent(false);
        }
    }, [showBar])

    if(!isInitialized){
        return null;
    }
    
    const creditsToShow = formatCredits(global);

    return (  
        <footer className={`bottom-nav ${isLightBg ? 'lightBg' : 'darkBg'}`} role={ADALandmarks.ContentInfo} aria-label="credits">
            <div className={`bn-hover-area ${showBar ? 'active' : ''}`}>
                <div className={`bn-credits-bar ${showBar ? 'active' : ''}`}>
                    <div className="bn-cb-main-line">
                        <div className="cpvi-grid-container">
                        <div className="cpvi-grid-row">
                            <div className="cpvi-grid-col w12">
                                <div className="bn-cb-trigger" onClick={ onCreditsClick } tabIndex={ 0} role={ADAWidgitRoles.Button}>
                                    <div className="bn-cb-trigger-title">{global.CreditText}</div>
                                    <BsChevronDown className={ showBar && showContent ? 'chevron active' : 'chevron inactive'} />
                                </div>  
                            </div>
                        </div>
                        </div>
                    </div>
                    {/* <div className={`bn-cb-full-content ${ showBar && showContent ? 'show' : 'hide' }`}>
                        <div className="bn-bg" onClick={onBackgroundClicked} />
                        <div className="cpvi-grid-container">
                            {creditsToShow}
                        </div>
                    </div> */}
                </div>
            </div>
        </footer>
    );
};

export default Credits;
